import {APIError} from '@/src/shared/lib/fetcher/error'
import {getHeaders} from '@/src/shared/lib/fetcher/get-headers'
import {FetcherParams} from '@/src/shared/lib/fetcher/types'
import {refreshTokenClient} from '@/src/shared/lib/fetcher/refresh-token-client'
import {refreshTokenServer} from '@/src/shared/lib/fetcher/refresh-token-server'

export async function fetcher<Data>(params: FetcherParams): Promise<Data> {
  const {headers, method, url, body, isAuth = false, token} = params
  const isServer = typeof window === 'undefined'
  const mergedHeaders = await getHeaders(isAuth, headers, isServer)
  const response = await fetch(url, {
    body: typeof body === 'string' ? body : JSON.stringify(body),
    method,
    headers: {
      ...mergedHeaders,
      ...(token && {Authorization: `Bearer ${token}`}),
    },
  })

  if (response.status === 401) {
    let token: string | undefined
    if (isServer) {
      const tokens = await refreshTokenServer()
      if (tokens) {
        token = tokens.newAccessToken
      }
    } else {
      await refreshTokenClient()
    }
    const mergedHeaders = await getHeaders(isAuth, headers, isServer)
    const response = await fetch(url, {
      body: typeof body === 'string' ? body : JSON.stringify(body),
      method,
      headers: {
        ...mergedHeaders,
        ...(token && {Authorization: `Bearer ${token}`}),
      },
    })
    if (!response.ok) {
      const error = await response.json()

      Logger(
        {
          message: response.statusText,
          code: error.code || 'error.unknownError',
          status: response.status,
          apiUrl: url,
          userInformation: getUserInformation(mergedHeaders),
        },
        isServer
      )

      const errorMessage =
        error.message || error.fieldErrors?.[0]?.message || response.statusText
      const errorCode = error.code || 'error.unknownError'
      const errorStatus = error.status || response.status

      throw new APIError(errorMessage, errorCode, errorStatus)
    }
    try {
      const data = await response.json()
      return data
    } catch {
      return {} as Data
    }
  }

  if (!response.ok && response.status !== 401) {
    const error = await response.json()

    Logger(
      {
        message: response.statusText,
        code: error.code || 'error.unknownError',
        status: response.status,
        apiUrl: url,
        userInformation: getUserInformation(mergedHeaders),
      },
      isServer
    )

    const errorMessage =
      error.message || error.fieldErrors?.[0]?.message || response.statusText
    const errorCode = error.code || 'error.unknownError'
    const errorStatus = error.status || response.status

    throw new APIError(errorMessage, errorCode, errorStatus)
  }
  try {
    const data = await response.json()
    return data
  } catch {
    return {} as Data
  }
}

export async function Logger(body: unknown, isServer: boolean) {
  fetcher({
    url: `${isServer ? process.env.NEXT_PUBLIC_FE_LOCAL : ''}/api/logger`,
    body,
    method: 'POST',
    isAuth: false,
  })
}

const getUserInformation = (mergedHeaders?: HeadersInit) => {
  const headers = new Headers(mergedHeaders)
  return {
    'x-trace-id': headers.get('x-trace-id') || '',
    'x-trace-email': headers.get('x-trace-email') || '',
    'x-advicemy-id': headers.get('x-advicemy-id') || '',
  }
}
